import React, { useState, useEffect } from "react";

export default function InputWithSuggestions({ suggestions = [], value = "", onChange, ...props }) {

	// const [val, setVal] = useState(value);
	const [active, setActive] = useState(false);
	const [closing, setClosing] = useState(false);

	const matches = suggestions.filter(suggestion => (
		!value || (suggestion !== value && suggestion.toLowerCase().includes(value.toLowerCase()))
	));

	useEffect(() => {
		let to;
		if (closing) {
			to = setTimeout(() => {
				setActive(false);
				setClosing(false);
			}, 100);
		}
		return () => {
			clearTimeout(to);
		}
	}, [closing]);

	return <div className="inputWithSuggestions">
		<input
			type="text"
			value={value || ""}
			onFocus={e => {
				setActive(true);
				setClosing(false);
				e.target.select();
			}}
			onBlur={e => {
				if (active) setClosing(true);
			}}
			onChange={e => {
				onChange(e.target.value);
			}}
			{...props}
		/>
		<div className={`suggestions suggestions-${active && matches.length ? "open" : "closed"}`}>
			{matches.map(match => (
				<div
					className="match"
					key={match}
					onClick={e => {
						onChange(match);
						setActive(false);
						setClosing(false);
					}}
				>
					{match}
				</div>
			))}
		</div>
	</div>
}